import React from "react";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import "./PolicyPage.scss";

const PolicyPage = () => {
  return (
    <>
      <Header />

      <div className="policy-page-container">
        <h1>Политика конфиденциальности</h1>
        <p>
          Данная Политика конфиденциальности (далее — «Политика») описывает, как 
          мы собираем, используем и обрабатываем ваши персональные данные при 
          посещении и использовании нашего сайта.
        </p>

        <h2>1. Сбор и использование персональных данных</h2>
        <p>
          1.1. Мы можем собирать персональные данные (например, имя, email) 
          только в случае, если вы добровольно предоставляете их при регистрации, 
          оформлении заказа или подписке на рассылку.  
          1.2. Собранные данные используются 
          исключительно для предоставления услуг и улучшения качества нашего 
          сервиса.
        </p>

        <h2>2. Файлы «cookie» и иные технологии</h2>
        <p>
          2.1. Мы используем файлы «cookie», пиксели и аналогичные технологии 
          для персонализации контента, запоминания ваших предпочтений и анализа 
          трафика.  
          2.2. Вы можете отключить хранение «cookie» в настройках браузера, 
          однако это может повлиять на некоторые функции сайта.
        </p>

        <h2>3. Передача данных третьим лицам</h2>
        <p>
          3.1. Мы не передаём вашу персональную информацию третьим лицам, за 
          исключением случаев, когда это необходимо для выполнения услуг 
          (например, службе доставки) или предусмотрено законом.  
          3.2. Все партнёры, 
          получающие данные, обязаны соблюдать требования конфиденциальности.
        </p>

        <h2>4. Безопасность данных</h2>
        <p>
          4.1. Мы принимаем разумные меры безопасности для защиты персональных 
          данных от несанкционированного доступа, изменения или уничтожения.  
          4.2. Однако ни один метод передачи информации через интернет не может 
          быть абсолютно безопасен, поэтому мы не можем гарантировать 
          абсолютной защиты.
        </p>

        <h2>5. Изменения в Политике</h2>
        <p>
          5.1. Мы можем периодически обновлять данную Политику, размещая 
          новую редакцию на сайте. Дата последнего обновления указывается 
          в начале документа.  
          5.2. Продолжая использование сайта после внесения 
          изменений, вы принимаете эти изменения.
        </p>

        <h2>6. Контакты</h2>
        <p>
          Если у вас возникли вопросы по поводу нашей Политики, свяжитесь с нами 
          по адресу: <a href="mailto:privacy@example.com">privacy@example.com</a>
        </p>
      </div>

      <Footer />
    </>
  );
};

export default PolicyPage;
